/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Button } from '@components';
import { balanceCoins } from '@utils/params';

const buyCoins = [
	{ coin: 'zchn', coinName: '0Chain', path: '/0chain' },
	{ coin: 'zrx', coinName: '0x Protocol', path: '/0x-protocol' },
	{ coin: 'act', coinName: 'Achain', path: '/achain' },
	{ coin: 'cpx', coinName: 'Apex', path: '/apex' },
	{ coin: 'aeon', coinName: 'Aeon', path: '/aeon' },
	{ coin: 'ardr', coinName: 'Ardor', path: '/ardor' },
	{ coin: 'xas', coinName: 'Asch Coin', path: '/aschcoin' },
	{ coin: 'ark', coinName: 'Ark', path: '/ark' },
	{ coin: 'rep', coinName: 'Augur', path: '/augur' },
	{ coin: 'bnb', coinName: 'Binance Coin', path: '/binancecoin' },
	{ coin: 'btc', coinName: 'Bitcoin', path: '/bitcoin' },
	{ coin: 'bch', coinName: 'Bitcoin Cash', path: '/bitcoincash' },
	{ coin: 'btcd', coinName: 'BitcoinDark', path: '/bitcoindark' },
	{ coin: 'btx', coinName: 'Bitcore', path: '/bitcore' },
	{ coin: 'bts', coinName: 'BitShares', path: '/bitshares' },
	{ coin: 'btg', coinName: 'Bitcoin Gold', path: '/bitcoingold' },
	{ coin: 'blz', coinName: 'Bluzelle', path: '/bluzelle' },
	{ coin: 'block', coinName: 'Blocknet', path: '/blocknet' },
	{ coin: 'bco', coinName: 'BridgeCoin', path: '/bridgecoin' },
	{ coin: 'burst', coinName: 'Burstcoin', path: '/burstcoin' },
	{ coin: 'gbyte', coinName: 'Byteball Bytes', path: '/byteball' },
	{ coin: 'bcn', coinName: 'Bytecoin', path: '/bytecoin' },
	{ coin: 'cloak', coinName: 'CloakCoin', path: '/cloakcoin' },
	{ coin: 'ada', coinName: 'Cardano', path: '/cardano' },
	{ coin: 'emb', coinName: 'Block Collider', path: '/block-collider' },
	{ coin: 'xcp', coinName: 'Counterparty', path: '/counterparty' },
	{ coin: 'crw', coinName: 'Crown', path: '/crown' },
	{ coin: 'dash', coinName: 'Dash', path: '/dash' },
	{ coin: 'dcr', coinName: 'Decred', path: '/decred' },
	{ coin: 'dct', coinName: 'Decent', path: '/decent' },
	{ coin: 'dbc', coinName: 'DeepBrain Chain', path: '/deepbrainchain' },
	{ coin: 'onion', coinName: 'DeepOnion', path: '/deeponion' },
	{ coin: 'dmd', coinName: 'Diamond', path: '/diamond' },
	{ coin: 'dgb', coinName: 'DigiByte', path: '/digibyte' },
	{ coin: 'dgd', coinName: 'DigixDAO', path: '/digixdao' },
	{ coin: 'dme', coinName: 'Dimecoin', path: '/dimecoin' },
	{ coin: 'doge', coinName: 'Dogecoin', path: '/dogecoin' },
	{ coin: 'efx', coinName: 'Effect AI', path: '/effect-ai' },
	{ coin: 'emc2', coinName: 'Einsteinium', path: '/einsteinium' },
	{ coin: 'etn', coinName: 'Electroneum', path: '/electroneum' },
	{ coin: 'emc', coinName: 'Emercoin', path: '/emercoin' },
	{ coin: 'eca', coinName: 'Electra', path: '/electra' },
	{ coin: 'eos', coinName: 'EOS', path: '/eos' },
	{ coin: 'ram', coinName: 'EOS RAM', path: '/eos-ram' },
	{ coin: 'etc', coinName: 'Ethereum Classic', path: '/ethereumclassic' },
	{ coin: 'eth', coinName: 'Ethereum', path: '/ethereum' },
	{ coin: 'xp', coinName: 'Experience Points', path: '/experience-points' },
	{ coin: 'fct', coinName: 'Factom', path: '/factom' },
	{ coin: 'ftc', coinName: 'Feathercoin', path: '/feathercoin' },
	{ coin: 'grs', coinName: 'Groestlcoin', path: '/groestlcoin' },
	{ coin: 'flash', coinName: 'Flash', path: '/flash' },
	{ coin: 'game', coinName: 'GameCredits', path: '/gamecredits' },
	{ coin: 'htc', coinName: 'Hempcoin', path: '/hempcoin' },
	{ coin: 'hsr', coinName: 'HShare', path: '/hshare' },
	{ coin: 'html', coinName: 'HTMLCOIN', path: '/htmlcoin' },
	{ coin: 'nlg', coinName: 'Gulden', path: '/gulden' },
	{ coin: 'icx', coinName: 'Icon', path: '/icon' },
	{ coin: 'ioc', coinName: 'I/O Coin', path: '/iocoin' },
	{ coin: 'ion', coinName: 'ION', path: '/ion' },
	{ coin: 'iota', coinName: 'Iota', path: '/iota' },
	{ coin: 'kmd', coinName: 'Komodo', path: '/komodo' },
	{ coin: 'lbc', coinName: 'Library Credits', path: '/library-credits' },
	{ coin: 'kcs', coinName: 'Kucoin', path: '/kucoin' },
	{ coin: 'lsk', coinName: 'Lisk', path: '/lisk' },
	{ coin: 'ltc', coinName: 'Litecoin', path: '/litecoin' },
	{ coin: 'lkk', coinName: 'Lykke Coin', path: '/lykkecoin' },
	{ coin: 'loom', coinName: 'Loom', path: '/loom-network' },
	{ coin: 'etp', coinName: 'Metaverse ETP', path: '/metaverseetp' },
	{ coin: 'lrc', coinName: 'Loopring', path: '/loopring' },
	{ coin: 'mnx', coinName: 'MinexCoin', path: '/minexCoin' },
	{ coin: 'mona', coinName: 'Monacoin', path: '/monacoin' },
	{ coin: 'moon', coinName: 'Mooncoin', path: '/mooncoin' },
	{ coin: 'xmr', coinName: 'Monero', path: '/monero' },
	{ coin: 'nmc', coinName: 'Namecoin', path: '/namecoin' },
	{ coin: 'nav', coinName: 'NAV Coin', path: '/nav-coin' },
	{ coin: 'nem', coinName: 'NEM', path: '/nem' },
	{ coin: 'nebl', coinName: 'Neblio', path: '/neblio' },
	{ coin: 'neo', coinName: 'Neo', path: '/neo' },
	{ coin: 'nexo', coinName: 'Nexo', path: '/nexo' },
	{ coin: 'nxs', coinName: 'Nexus', path: '/nexus' },
	{ coin: 'nkn', coinName: 'NKN', path: '/nkn' },
	{ coin: 'omg', coinName: 'OmiseGo', path: '/omisego' },
	{ coin: 'olt', coinName: 'OneLedger', path: '/oneledger' },
	{ coin: 'ont', coinName: 'Ontology', path: '/ontology' },
	{ coin: 'pac', coinName: 'PACcoin', path: '/paccoin' },
	{ coin: 'part', coinName: 'Particl', path: '/particl' },
	{ coin: 'ppc', coinName: 'Peercoin', path: '/peercoin' },
	{ coin: 'pivx', coinName: 'Pivx', path: '/pivx' },
	{ coin: 'ppt', coinName: 'Populous', path: '/populous' },
	{ coin: 'poly', coinName: 'Polymath', path: '/polymath' },
	{ coin: 'powr', coinName: 'Power Ledger', path: '/power-ledger' },
	{ coin: 'pot', coinName: 'Potcoin', path: '/potcoin' },
	{ coin: 'pura', coinName: 'Pura', path: '/pura' },
	{ coin: 'qkc', coinName: 'Quarkchain', path: '/quarkchain-protocol' },
	{ coin: 'xrb', coinName: 'Raiblock', path: '/raiblocks' },
	{ coin: 'qlc', coinName: 'QLC Chain', path: '/qlc-chain' },
	{ coin: 'qtum', coinName: 'qtum', path: '/qtum' },
	{ coin: 'rpx', coinName: 'Red Pulse', path: '/redpulse' },
	{ coin: 'req', coinName: 'REQUEST', path: '/request' },
	{ coin: 'xrp', coinName: 'Ripple', path: '/ripple' },
	{ coin: 'shift', coinName: 'Shift', path: '/shift' },
	{ coin: 'ss', coinName: 'Sharder', path: '/sharder-protocol' },
	{ coin: 'sia', coinName: 'Siacoin', path: '/siacoin' },
	{ coin: 'sib', coinName: 'SIBcoin', path: '/sibcoin' },
	{ coin: 'sky', coinName: 'Skycoin', path: '/skycoin' },
	{ coin: 'xspec', coinName: 'Spectrecoin', path: '/spectrecoin' },
	{ coin: 'smart', coinName: 'SmartCash', path: '/smartcash' },
	{ coin: 'steem', coinName: 'Steem', path: '/steem' },
	{ coin: 'xlm', coinName: 'Stellar', path: '/stellar' },
	{ coin: 'strat', coinName: 'Stratis', path: '/stratis' },
	{ coin: 'sub', coinName: 'Substratum', path: '/substratum' },
	{ coin: 'sys', coinName: 'Syscoin', path: '/syscoin' },
	{ coin: 'usdt', coinName: 'Tether', path: '/tether' },
	{ coin: 'trx', coinName: 'Tron', path: '/tron' },
	{ coin: 'xvg', coinName: 'Verge', path: '/verge' },
	{ coin: 'vet', coinName: 'Vechain', path: '/vechain' },
	{ coin: 'vtc', coinName: 'Vertcoin', path: '/vertcoin' },
	{ coin: 'via', coinName: 'Viacoin', path: '/viacoin' },
	{ coin: 'vox', coinName: 'Voxels', path: '/voxels' },
	{ coin: 'wan', coinName: 'Wanchain', path: '/wanchain' },
	{ coin: 'waves', coinName: 'Waves', path: '/waves' },
	{ coin: 'wpr', coinName: 'WePower', path: '/wepower' },
	{ coin: 'xwc', coinName: 'WhiteCoin', path: '/whitecoin' },
	{ coin: 'xby', coinName: 'XTRABYTES', path: '/xtrabytes' },
	{ coin: 'zcl', coinName: 'ZClassic', path: '/zclassic' },
	{ coin: 'xzc', coinName: 'Zcoin', path: '/zcoin' },
	{ coin: 'zil', coinName: 'Zilliqa', path: '/zilliqa' },
];

const priceInrCoins = [
	{ coin: 'aeon', coinName: 'Aeon', path: '/aeon-price-inr-india' },
	{ coin: 'ardr', coinName: 'Ardor', path: '/ardor-price-inr-india' },
	{ coin: 'act', coinName: 'Achain', path: '/achain-price-inr-india' },
	{ coin: 'xas', coinName: 'Asch Coin', path: '/aschcoin-price-inr-india' },
	{ coin: 'ark', coinName: 'Ark', path: '/ark-price-inr-india' },
	{
		coin: 'bnb',
		coinName: 'Binance Coin',
		path: '/binancecoin-price-inr-india',
	},
	{ coin: 'btc', coinName: 'Bitcoin', path: '/bitcoin-price-inr-india' },
	{
		coin: 'btcd',
		coinName: 'BitcoinDark',
		path: '/bitcoindark-price-inr-india',
	},
	{
		coin: 'bch',
		coinName: 'Bitcoin Cash',
		path: '/bitcoincash-price-inr-india',
	},
	{ coin: 'btx', coinName: 'Bitcore', path: '/bitcore-price-inr-india' },
	{
		coin: 'btg',
		coinName: 'Bitcoin Gold',
		path: '/bitcoingold-price-inr-india',
	},
	{ coin: 'bts', coinName: 'Bitshares', path: '/bitshares-price-inr-india' },
	{
		coin: 'bco',
		coinName: 'BridgeCoin',
		path: '/bridgecoin-price-inr-india',
	},
	{ coin: 'blz', coinName: 'Bluzelle', path: '/bluzelle-price-inr-india' },
	{ coin: 'block', coinName: 'Blocknet', path: '/blocknet-price-inr-india' },
	{
		coin: 'burst',
		coinName: 'Burstcoin',
		path: '/burstcoin-price-inr-india',
	},
	{
		coin: 'gbyte',
		coinName: 'Byteball Bytes',
		path: '/byteball-price-inr-india',
	},
	{ coin: 'bcn', coinName: 'Bytecoin', path: '/bytecoin-price-inr-india' },
	{ coin: 'ada', coinName: 'Cardano', path: '/cardano-price-inr-india' },
	{
		coin: 'cloak',
		coinName: 'CloakCoin',
		path: '/cloakcoin-price-inr-india',
	},
	{
		coin: 'xcp',
		coinName: 'Counterparty',
		path: '/counterparty-price-inr-india',
	},
	{ coin: 'crw', coinName: 'Crown', path: '/crown-price-inr-india' },
	{ coin: 'dash', coinName: 'Dash', path: '/dash-price-inr-india' },
	{ coin: 'dct', coinName: 'Decent', path: '/decent-price-inr-india' },
	{
		coin: 'dbc',
		coinName: 'DeepBrain Chain',
		path: '/deepbrainchain-price-inr-india',
	},
	{
		coin: 'onion',
		coinName: 'DeepOnion',
		path: '/deeponion-price-inr-india',
	},
	{ coin: 'dcr', coinName: 'Decred', path: '/decred-price-inr-india' },
	{ coin: 'dgb', coinName: 'DigiByte', path: '/digibyte-price-inr-india' },
	{ coin: 'dmd', coinName: 'Diamond', path: '/diamond-price-inr-india' },
	{ coin: 'dime', coinName: 'Dimecoin', path: '/dimecoin-price-inr-india' },
	{ coin: 'doge', coinName: 'Dogecoin', path: '/dogecoin-price-inr-india' },
	{ coin: 'efx', coinName: 'Effect AI', path: '/effect-ai-price-inr-india' },
	{
		coin: 'emc2',
		coinName: 'Einsteinium',
		path: '/einsteinium-price-inr-india',
	},
	{ coin: 'eca', coinName: 'Electra', path: '/electra-price-inr-india' },
	{
		coin: 'etn',
		coinName: 'Electroneum',
		path: '/electroneum-price-inr-india',
	},
	{ coin: 'eos', coinName: 'EOS', path: '/eos-price-inr-india' },
	{ coin: 'emc', coinName: 'Emercoin', path: '/emercoin-price-inr-india' },
	{ coin: 'ram', coinName: 'EOS RAM', path: '/eos-ram-price-inr-india' },
	{ coin: 'eth', coinName: 'Ethereum', path: '/ethereum-price-inr-india' },
	{
		coin: 'etc',
		coinName: 'Ethereum Classic',
		path: '/ethereumclassic-price-inr-india',
	},
	{ coin: 'fct', coinName: 'Factom', path: '/factom-price-inr-india' },
	{
		coin: 'xp',
		coinName: 'Experience Points',
		path: '/experience-points-price-inr-india',
	},
	{
		coin: 'ftc',
		coinName: 'Feathercoin',
		path: '/feathercoin-price-inr-india',
	},
	{ coin: 'flash', coinName: 'Flash', path: '/flash-price-inr-india' },
	{
		coin: 'game',
		coinName: 'GameCredits',
		path: '/gamecredits-price-inr-india',
	},
	{
		coin: 'grs',
		coinName: 'Groestlcoin',
		path: '/groestlcoin-price-inr-india',
	},
	{ coin: 'nlg', coinName: 'Gulden', path: '/gulden-price-inr-india' },
	{ coin: 'hsr', coinName: 'HShare', path: '/hshare-price-inr-india' },
	{ coin: 'thc', coinName: 'Hempcoin', path: '/hempcoin-price-inr-india' },
	{ coin: 'icx', coinName: 'Icon', path: '/icon-price-inr-india' },
	{ coin: 'ioc', coinName: 'I/O Coin', path: '/iocoin-price-inr-india' },
	{ coin: 'miota', coinName: 'Iota', path: '/iota-price-inr-india' },
	{ coin: 'ion', coinName: 'ION', path: '/ion-price-inr-india' },
	{ coin: 'kcs', coinName: 'Kucoin', path: '/kucoin-price-inr-india' },
	{ coin: 'kmd', coinName: 'Komodo', path: '/komodo-price-inr-india' },
	{
		coin: 'lbc',
		coinName: 'LBRY Credits',
		path: '/library-credits-price-inr-india',
	},
	{ coin: 'lsk', coinName: 'Lisk', path: '/lisk-price-inr-india' },
	{
		coin: 'loom',
		coinName: 'Loom Network',
		path: '/loom-network-price-inr-india',
	},
	{ coin: 'ltc', coinName: 'Litecoin', path: '/litecoin-price-inr-india' },
	{ coin: 'lkk', coinName: 'Lykke Coin', path: '/lykkecoin-price-inr-india' },
	{ coin: 'lrc', coinName: 'Loopring', path: '/loopring-price-inr-india' },
	{
		coin: 'etp',
		coinName: 'Metaverse ETP',
		path: '/metaverseetp-price-inr-india',
	},
	{ coin: 'mnx', coinName: 'Minexcoin', path: '/minexcoin-price-inr-india' },
	{ coin: 'mona', coinName: 'Monacoin', path: '/monacoin-price-inr-india' },
	{ coin: 'xmr', coinName: 'Monero', path: '/monero-price-inr-india' },
	{ coin: 'nav', coinName: 'NAV Coin', path: '/nav-coin-price-inr-india' },
	{ coin: 'nmc', coinName: 'Namecoin', path: '/namecoin-price-inr-india' },
	{ coin: 'nebl', coinName: 'Neblio', path: '/neblio-price-inr-india' },
	{ coin: 'moon', coinName: 'Mooncoin', path: '/mooncoin-price-inr-india' },
	{ coin: 'neo', coinName: 'Neo', path: '/neo-price-inr-india' },
	{ coin: 'xem', coinName: 'Nem', path: '/nem-price-inr-india' },
	{ coin: 'nexo', coinName: 'NEXO', path: '/nexo-price-inr-india' },
	{ coin: 'omg', coinName: 'OmiseGo', path: '/omisego-price-inr-india' },
	{ coin: 'nxs', coinName: 'Nexus', path: '/nexus-price-inr-india' },
	{ coin: 'ont', coinName: 'Ontology', path: '/ontology-price-inr-india' },
	{ coin: 'part', coinName: 'Particl', path: '/particl-price-inr-india' },
	{ coin: 'pac', coinName: 'PACcoin', path: '/paccoin-price-inr-india' },
	{ coin: 'ppc', coinName: 'Peercoin', path: '/peercoin-price-inr-india' },
	{ coin: 'pivx', coinName: 'Pivx', path: '/pivx-price-inr-india' },
	{ coin: 'poly', coinName: 'Polymath', path: '/polymath-price-inr-india' },
	{ coin: 'ppt', coinName: 'Populous', path: '/populous-price-inr-india' },
	{ coin: 'pot', coinName: 'Potcoin', path: '/potcoin-price-inr-india' },
	{ coin: 'pura', coinName: 'Pura', path: '/pura-price-inr-india' },
	{ coin: 'qtum', coinName: 'QTUM', path: '/qtum-price-inr-india' },
	{ coin: 'xrb', coinName: 'Raiblocks', path: '/raiblocks-price-inr-india' },
	{ coin: 'rpx', coinName: 'Red Pulse', path: '/redpulse-price-inr-india' },
	{ coin: 'xrp', coinName: 'Ripple', path: '/ripple-price-inr-india' },
	{ coin: 'req', coinName: 'Request', path: '/request-price-inr-india' },
	{ coin: 'shift', coinName: 'Shift', path: '/shift-price-inr-india' },
	{ coin: 'sia', coinName: 'Siacoin', path: '/siacoin-price-inr-india' },
	{ coin: 'sky', coinName: 'Skycoin', path: '/skycoin-price-inr-india' },
	{ coin: 'sib', coinName: 'SIBCoin', path: '/sibCoin-price-inr-india' },
	{
		coin: 'smart',
		coinName: 'Smartcash',
		path: '/smartcash-price-inr-india',
	},
	{
		coin: 'xspec',
		coinName: 'Spectrecoin',
		path: '/spectrecoin-price-inr-india',
	},
	{
		coin: 'sbd',
		coinName: 'Steem Dollars',
		path: '/steemdollars-price-inr-india',
	},
	{ coin: 'steem', coinName: 'Steem', path: '/steem-price-inr-india' },
	{ coin: 'xlm', coinName: 'Stellar', path: '/stellar-price-inr-india' },
	{ coin: 'strat', coinName: 'Stratis', path: '/stratis-price-inr-india' },
	{
		coin: 'sub',
		coinName: 'Substratum',
		path: '/substratum-price-inr-india',
	},
	{ coin: 'sys', coinName: 'Syscoin', path: '/syscoin-price-inr-india' },
	{ coin: 'usdt', coinName: 'Tether', path: '/tether-price-inr-india' },
	{ coin: 'trx', coinName: 'Tron', path: '/tron-price-inr-india' },
	{ coin: 'vet', coinName: 'Vechain', path: '/vechain-price-inr-india' },
	{ coin: 'xvg', coinName: 'Verge', path: '/verge-price-inr-india' },
	{ coin: 'vtc', coinName: 'Vertcoin', path: '/vertcoin-price-inr-india' },
	{ coin: 'via', coinName: 'Viacoin', path: '/viacoin-price-inr-india' },
	{ coin: 'wan', coinName: 'Wanchain', path: '/wanchain-price-inr-india' },
	{ coin: 'vox', coinName: 'Voxels', path: '/voxels-price-inr-india' },
	{ coin: 'xwc', coinName: 'WhiteCoin', path: '/whitecoin-price-inr-india' },
	{ coin: 'waves', coinName: 'Waves', path: '/waves-price-inr-india' },
	{ coin: 'xby', coinName: 'XTRABYTES', path: '/xtrabytes-price-inr-india' },
	{ coin: 'zec', coinName: 'ZCash', path: '/zcash-price-inr-india' },
	{ coin: 'zcl', coinName: 'ZClassic', path: '/zclassic-price-inr-india' },
	{ coin: 'xzc', coinName: 'Zcoin', path: '/zcoin-price-inr-india' },
	{ coin: 'zil', coinName: 'Zilliqa', path: '/zilliqa-price-inr-india' },
];

const tradingBuyCoins = [];
const nonTradingBuyCoins = [];

buyCoins.forEach(buyCoin => {
	if (balanceCoins.indexOf(buyCoin.coin) > -1) {
		tradingBuyCoins.push(buyCoin);
	} else {
		nonTradingBuyCoins.push(buyCoin);
	}
});

const sortedBuyCoins = [...tradingBuyCoins, ...nonTradingBuyCoins];

const tradingPriceCoins = [];
const nonTradingPriceCoins = [];

priceInrCoins.forEach(priceInrCoin => {
	if (balanceCoins.indexOf(priceInrCoin.coin) > -1) {
		tradingPriceCoins.push(priceInrCoin);
	} else {
		nonTradingPriceCoins.push(priceInrCoin);
	}
});

const sortedPriceInrCoins = [...tradingPriceCoins, ...nonTradingPriceCoins];

const CoinBuyList = ({ singleLine, up, coin }) => (
	<div
		className={`container px-2 mx-auto mb-8 ${
			singleLine === true ? 'whitespace-nowrap flex items-center' : ''
		} ${up === true ? 'max-w-6xl' : ''}`}
	>
		<h4
			className={`text-sm font-bold ${
				singleLine === true ? 'm-0 mr-4 pb-2' : 'my-4'
			}`}
		>
			Buy Coins:
		</h4>
		<div
			className={`${
				singleLine === true
					? 'u-scrollBar overflow-x-auto overflow-y-hidden whitespace-nowrap'
					: 'my-4'
			}`}
		>
			{sortedBuyCoins.map(({ coin: buyCoin, coinName, path }) => (
				<Button
					key={buyCoin}
					link={`${path}/`}
					className={`m-2 ${coin === buyCoin ? 'hidden' : ''}`}
					size="tiny"
					variant="outline"
				>
					Buy {coinName}
				</Button>
			))}
		</div>
	</div>
);

const CoinPriceList = ({ singleLine, up, coin }) => (
	<div
		className={`container px-2 mx-auto mb-8 ${
			singleLine === true ? 'whitespace-nowrap flex items-center' : ''
		} ${up === true ? 'max-w-6xl' : ''}`}
	>
		<h4
			className={`text-sm font-bold ${
				singleLine === true ? 'm-0 mr-4 pb-2' : 'my-4'
			}`}
		>
			Price Links:
		</h4>
		<div
			className={`${
				singleLine === true
					? 'u-scrollBar overflow-x-auto overflow-y-hidden whitespace-nowrap'
					: 'my-4'
			}`}
		>
			{sortedPriceInrCoins.map(({ coin: priceCoin, coinName, path }) => (
				<Button
					size="tiny"
					key={priceCoin}
					link={`${path}/`}
					className={`m-2 ${coin === priceCoin ? 'hidden' : ''}`}
					variant="outline"
				>
					{coinName} Price
				</Button>
			))}
		</div>
	</div>
);

export const CoinsList = ({ buy, price, ...props }) => (
	<div className="expressLinks bg-snowWhite u-scrollBar py-4">
		{buy === true ? <CoinBuyList {...props} /> : ''}
		{price === true ? <CoinPriceList {...props} /> : ''}
	</div>
);
